import {
  DropdownPrimeReact,
  DropdownPrimeReactProps,
} from "@finanedi.es/storybook"
import {
  InfiniteData,
  QueryObserverResult,
  RefetchOptions,
} from "@tanstack/react-query"
import { EntidadBancariaDtoProps } from "api/DTOs/EntidadBancariaDto"
import { EntidadBancariaDtoIPagedEnumerableProps } from "api/Schemas/EntidadBancariaDtoIPagedEnumerable"
import { TFunction } from "i18next"
import { VirtualScrollerLazyParams } from "primereact/virtualscroller"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"

interface FormikDocumentsProps extends DropdownPrimeReactProps {
  value?: string
  onchange: ({ value }: { value: string }) => void
  disabled?: boolean
  pushDefaultOption?: Record<string, string>
  dataBank:
    | InfiniteData<EntidadBancariaDtoIPagedEnumerableProps, unknown>
    | undefined
  fetchNextPage: (
    options?: RefetchOptions | undefined
  ) => Promise<
    QueryObserverResult<
      InfiniteData<EntidadBancariaDtoIPagedEnumerableProps, unknown>,
      Error
    >
  >
  isFetchingNextPage: boolean
  refetch: (
    options?: RefetchOptions | undefined
  ) => Promise<
    QueryObserverResult<
      InfiniteData<EntidadBancariaDtoIPagedEnumerableProps, unknown>,
      Error
    >
  >
  setKeyWord: React.Dispatch<React.SetStateAction<string>>
  bankList: EntidadBancariaDtoProps[]
  setBankList: React.Dispatch<React.SetStateAction<EntidadBancariaDtoProps[]>>
}

const DropdownBanks = ({
  value,
  onchange,
  disabled = false,
  dataBank,
  fetchNextPage,
  isFetchingNextPage,
  refetch,
  setKeyWord,
  bankList,
  setBankList,
  ...props
}: FormikDocumentsProps) => {
  const { t }: { t: TFunction } = useTranslation()

  useEffect(() => {
    const nuevosBancos = dataBank?.pages?.flatMap((page) => page?.items) ?? []

    const bancosFiltrados = nuevosBancos.filter(
      (banco) => banco !== null && banco !== undefined
    )

    if (bancosFiltrados.length > 0) {
      setBankList(bancosFiltrados as EntidadBancariaDtoProps[])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataBank, disabled])

  const loadMoreData = (event: VirtualScrollerLazyParams) => {
    if (!isFetchingNextPage && event.last === bankList.length) {
      if (
        dataBank &&
        dataBank.pages &&
        dataBank.pages.length > 0 &&
        bankList.length <= (dataBank.pages[0]?.totalCount ?? 0)
      ) {
        fetchNextPage()
      }
    }
  }

  const onContactoFilter = async ({ filter }: { filter: string }) => {
    await setKeyWord(filter || "")
    refetch()
  }

  return (
    <DropdownPrimeReact
      value={value}
      placeholder={`${t("remesas.edit.form.placeholderContacto")}`}
      onChange={onchange}
      style={{ maxWidth: "100%" }}
      options={bankList}
      optionLabel='nombre'
      optionValue='id'
      className='!tw-rounded !tw-max-w-full !tw-w-full tw-border-1 !tw-h-10 tw-items-center tw-align-middle !tw-p-0 tw-mb-2'
      filter
      emptyMessage={`${t("cuentasContables.notElementAccounts")}`}
      scrollHeight='350px'
      filterMatchMode='contains'
      onFilter={onContactoFilter}
      virtualScrollerOptions={{
        lazy: true,
        onLazyLoad: loadMoreData,
        itemSize: 38,
        showLoader: false,
      }}
      disabled={disabled}
      {...props}
    />
  )
}

export default DropdownBanks
